import React from "react";
import {
  ImageFortyFive,
  ImageFortyFour,
  ImageFortySix,
  ImageFortyThree,
  ImageFortyTwo,
} from "../assets/images";

const ThirteenTab = () => {
  return (
    <div className="text-center px-5 py-10 font-sans">
      {/* Heading */}
      <div>
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-2">
          Community & Support Ecosystem
        </h2>
        <p className="text-gray-600 text-base md:text-lg mb-8">
          Connection, knowledge, and compassion—because healing is never done
          alone.
        </p>
      </div>

      {/* Cards Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center mb-10">
        <div className="bg-white rounded-xl shadow-md p-4 text-center">
          <img
            src={ImageFortyTwo}
            alt="Weekly webinars"
            className="w-[100px] h-[100px] mx-auto mb-4 object-contain"
          />
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Weekly webinars
          </h3>
          <p className="text-base text-gray-600">
            with oncologists, nutritionists, and survivors
          </p>
        </div>

        {/* Card 2 */}
        <div className="bg-white rounded-xl shadow-md p-4 text-center">
          <img
            src={ImageFortyThree}
            alt="Survivors"
            className="w-[100px] h-[100px] mx-auto mb-4 object-contain"
          />
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Survivors
          </h3>
          <p className="text-base text-gray-600">
            Safe, moderated peer groups and chat rooms
          </p>
        </div>

        {/* Card 3 */}
        <div className="bg-white rounded-xl shadow-md p-4 text-center">
          <img
            src={ImageFortyFour}
            alt="Personal journeys"
            className="w-[100px] h-[100px] mx-auto mb-4 object-contain"
          />
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Personal journeys
          </h3>
          <p className="text-base text-gray-600">that inspire others</p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-8 md:gap-16 mb-10">
        {/* Item 1 */}
        <div className="flex flex-col items-center text-center w-full sm:w-[200px]">
          <img
            src={ImageFortyFive}
            alt="Private journaling"
            className="w-[100px] h-[100px] mb-3 object-contain"
          />
          <span className="text-lg text-gray-800 font-medium">
            Private journaling & emotional tools
          </span>
        </div>

        {/* Item 2 */}
        <div className="flex flex-col items-center text-center w-full sm:w-[220px]">
          <img
            src={ImageFortySix}
            alt="Resource bank"
            className="w-[100px] h-[100px] mb-3 object-contain"
          />
          <span className="text-lg text-gray-800 font-medium">
            Comprehensive resource bank & Q&amp;A support
          </span>
        </div>
      </div>

      {/* Highlighted Message */}
      <div className="bg-teal-700 text-white px-5 py-3 rounded-full inline-block mb-6 text-sm md:text-base">
        A safe circle for sharing, learning, and supporting one another.
      </div>

      {/* Button */}
      <div>
        <button className="bg-teal-700 hover:bg-teal-800 text-white px-6 py-3 rounded-lg text-base font-medium transition">
          Join the Community
        </button>
      </div>
    </div>
  );
};

export default ThirteenTab;
